<template>
  <FlotoCrudContainer
    ref="kbListRef"
    :fetch-fn="fetchKb"
    :scrollable="false"
    as-table
    :columns="columns"
  >
    <template v-slot:name="{ item }">
      <td>
        <ResourceListTitle
          :name="item.name"
          :requester-name="folder ? undefined : item.folderName"
          :subject="item.subject"
          :created-at="item.createdAt"
          :link="$currentModule.getRoute('read', { params: { id: item.id } })"
        />
      </td>
    </template>
    <template v-slot:created_by="{ item }">
      <td>
        <FlotoTechnicianPicker :value="item.owner" disabled />
      </td>
    </template>
    <template v-slot:status="{ item }">
      <td>
        <FlotoDropdownPicker
          :value="item.status"
          disabled
          :options="statusOptions"
        />
      </td>
    </template>
    <template v-slot:approvalStatus="{ item }">
      <td>
        <span v-if="item.approvalStatus">{{ $tc(item.approvalStatus) }}</span>
        <span v-else>---</span>
      </td>
    </template>
    <template v-slot:thumbs="{ item }">
      <td>
        <FeedbackCount
          :positive-feedback="item.positiveFeedback"
          :negative-feedback="item.negativeFeedback"
        />
      </td>
    </template>
  </FlotoCrudContainer>
</template>

<script>
import { authComputed } from '@state/modules/auth'
import { KnowledgeStatusOptions } from '@utils/status'
import { searchKnowledgeApi } from '../knowledge-api'
import ResourceListTitle from '@components/resource/resource-list-title'
import FeedbackCount from './feedback-count'

export default {
  name: 'KBList',
  components: { ResourceListTitle, FeedbackCount },
  props: {
    folder: { type: Object, default: undefined },
    searchCriteria: { type: [Array, Object], required: true },
    hiddenColumns: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    this.statusOptions = KnowledgeStatusOptions()
    return {}
  },
  computed: {
    ...authComputed,
    columns() {
      const allColumns = [
        {
          name: this.$t('name'),
          key: 'name',
          minWidth: '100px',
        },
        {
          name: this.$t('author'),
          key: 'created_by',
        },
        {
          name: this.$t('status'),
          key: 'status',
          resizable: false,
        },
        ...(this.hiddenColumns.indexOf('approvalStatus') < 0
          ? [
              {
                name: `${this.$tc('approval')} ${this.$tc('status')}`,
                key: 'approvalStatus',
              },
            ]
          : []),
        {
          name: '',
          key: 'thumbs',
          width: '150px',
          resizable: false,
        },
      ]
      return allColumns
    },
  },
  watch: {
    folder() {
      this.$nextTick(() => this.$refs.kbListRef.refresh())
    },
    searchCriteria() {
      this.$nextTick(() => this.$refs.kbListRef.refresh())
    },
  },
  methods: {
    fetchKb(limit, offset) {
      return searchKnowledgeApi(
        {
          folderId: (this.folder || {}).id,
          public: this.isPortalLogin,
        },
        this.searchCriteria || [],
        limit,
        offset
      )
    },
  },
}
</script>
